module.exports = __webpack_public_path__ + "media/assets/images/sunny_sometime_will_rain-a5fc40570a149a748df87b2b7f223d62.png";